<template>
  <main role="main" class="main bg-navy">
    <div class="bg-navy d-block d-md-none">
      <b-row class="no-gutters">
        <b-col class="text-center">
          <b-button type="button" variant="link" class="color-white float-left py-3" to="/home">
            <feather type="arrow-left"></feather>
          </b-button>
          <span class="d-inline-block h-100 title-w-60">
            <span class="d-table h-100">
              <span class="d-table-cell align-middle">
                <strong class="color-white">Beneficiaries</strong>
              </span>
            </span>
          </span>
        </b-col>
      </b-row>
    </div>
    <div class="mobile-vh min-h-100 p-4 p-md-5 bg-white mobi-rounded-top">
      <b-row class="custom-height">
        <b-col lg="10" offset-lg="1">
          <profile-menu></profile-menu>
          <h2 class="mobile-size-reduce color-navy-blue mb-3">Beneficiaries</h2>
          <div v-if="accountStatus === 'loaded' || accountStatus === 'not-found'">
            <div>
              <b-row class="text-center mt-2 mb-3">
                <b-col cols="12" md="6" class="mt-2 mb-1" offset-lg-1="1">
                  <!--<maz-input v-model="search" placeholder="Search beneficiaries" right-icon-name="search" />-->
                </b-col>
                <b-col cols="12" offset-md="2" md="4">
                  <b-button variant="outline-custom" pill block class="mt-3" href="#" @click.prevent="addBeneficiary()">
                    Add beneficiary
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <b-table striped hover :items="bankAccounts" :fields="tableFields" :per-page="perPage" :current-page="currentPage" responsive="sm">
              <template v-slot:cell(_id)="data">
                <a href="#" @click.prevent="editBeneficiary(data.item._id, data.item.currency)" class="mr-2">
                  <feather type="edit" stroke="#9190a8" size="14px"></feather>
                </a>
                <a href="#" @click.prevent="remove(data)">
                  <feather type="trash-2" stroke="#9190a8" size="14px"></feather>
                </a>
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              pills
              align="center"
              aria-controls="statement-table"
            ></b-pagination>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Upload bank confirmation modal -->
    <b-modal id="upload_bank" size="lg" centered hide-header hide-footer>
      <button type="button" aria-label="Close" class="close" @click="$bvModal.hide('upload_bank')">×</button>
      <h3 class="color-navy-blue mb-4">Requires attention!</h3>
      <b-form>
        <b-col md="12">
          <p><strong>Manual Verification:</strong></p>
          <p class="mb-0">Please upload Proof of Bank Account. Accepted documents: </p>
          <ul class="pl-3 mb-0">
            <li>Bank Stamped Confirmation Letter no older than 3 months</li>
            <li>Bank Stamped Statement no older than 3 months.</li>
          </ul>
          <p class="mt-0">These documents should be available for download directly from Internet Banking and/or the Mobile Banking App.</p>
        </b-col>
        <b-form-group class="col-md-12">
          <b-form-file multiple v-model="files" placeholder="File Upload for Proof of Bank Account *">
            <template slot="file-name" slot-scope="{ names }">
              <b-badge class="mr-1" variant="dark" v-for="(name, $index) in names" :key="$index">{{ name }}</b-badge>
            </template>
          </b-form-file>
        </b-form-group>
        <small class="ml-2 form-text text-muted" v-if="(files === null || files.length === 0)">Choose a file or drop it here</small>
        <a class="ml-4" href="#" @click.prevent="files = null" v-if="files && files.length >= 1"><small>
          <feather type="trash-2" size="14px"></feather>
          Reset file selection
        </small></a>
        <div class="ml-4" v-if="attachments">
          <strong>Existing attachments:</strong>
          <ul>
            <li v-for="file in attachments" :key="file._id">
              <a :href="file.path" target="_blank">{{ file.original_name }}</a>
            </li>
          </ul>
        </div>
        <b-form-group class="mb-0">
          <b-row>
            <b-col cols="12" md="6">
              <b-button type="button" @click="$bvModal.hide('upload_bank')" variant="outline-primary" pill block class="mt-3">Cancel</b-button>
            </b-col>
            <b-col cols="12" md="6">
              <loading-button :replace="uploading === true">
                <b-button type="submit" variant="custom" pill block class="mt-3" @click.prevent="startUpload()" :disabled="!files || files.length === 0">Upload</b-button>
              </loading-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </b-modal>
    <!-- End modal -->
  </main>
</template>

<script>
import { companyService } from '@/services'

import ProfileMenu from '@/components/organisation/ProfileMenu'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    ProfileMenu
  },
  data () {
    return {
      saving: false,
      perPage: 10,
      currentPage: 1,
      tableFields: [
        { key: 'name', sortable: true, label: 'Name' },
        { key: 'account_name', sortable: true, label: 'Account Holder' },
        { key: 'country', sortable: false, label: 'Country', class: 'd-none d-lg-table-cell' },
        { key: 'currency', sortable: false, label: 'Currency' },
        { key: 'bank', sortable: false, label: 'Bank' },
        { key: 'account_number', sortable: false, label: 'Account Number / IBAN', class: 'text-right' },
        { key: '_id', label: 'Actions', class: 'text-right' }
      ],
      details: {
        name: null,
        country: 'ZA',
        currency: 'ZAR',
        bank: null,
        branch: null,
        account_type: null,
        account_number: null,
        account_name: null,
        swift_code: null,
        sort_code: null,
        iban: null,
        bic_code: null,
        intermediary_bic: null
      },
      files: null,
      editing: null,
      uploading: false
    }
  },
  computed: {
    ...mapState({
      accounts: state => state.companyBeneficiaries,
      companies: state => state.company,
      countries: state => state.country.countries,
      banks: state => state.banks,
      currencies: state => state.currency.currencies,
      userStore: state => state.company
    }),
    accountStatus () {
      return this.accounts.status
    },
    bankAccounts () {
      const _accounts = []

      if (this.accountStatus === 'loaded' && this.accounts.accounts) {
        this.accounts.accounts.forEach(_account => {
          _accounts.push({
            _id: _account._id,
            name: _account.name,
            account_name: _account.account_name || (_account.beneficiary.companyname ? _account.beneficiary.companyname : _account.beneficiary.firstname + ' ' + _account.beneficiary.surname),
            country: _account.country,
            currency: _account.currency === 'ZARUK' ? 'ZAR' : _account.currency,
            bank: _account.bank,
            account_number: _account.account_number || _account.iban
          })
        })
      }

      return _accounts
    },
    attachments () {
      if (this.companies && this.companies.company && this.companies.company.attachments && this.companies.company.attachments.length > 0) {
        const _passports = this.companies.company.attachments.filter(_file => _file.category === 'Bank Account Confirmation')

        if (_passports && _passports.length > 0) {
          return _passports
        } else {
          return null
        }
      } else {
        return null
      }
    },
    totalRows () {
      return this.bankAccounts.length
    }
  },
  created () {
    this.getAccounts()
  },
  methods: {
    ...mapActions('currency', ['set']),
    ...mapActions('companyBeneficiaries', {
      getAccounts: 'get',
      saveAccount: 'save',
      deleteAccount: 'delete',
      editAccount: 'edit'
    }),
    getCountry: function (code) {
      return this.countries.find(country => country.code === code).name
    },
    save: async function () {
      this.saving = true
      this.saveAccount(this.details)
    },
    addBeneficiary () {
      this.$store.state.beneficiaryId = ''
      this.set('GBP')
      this.$bvModal.show('new_beneficiary')
    },
    editBeneficiary (beneficiaryId, currency) {
      this.$store.state.beneficiaryId = beneficiaryId
      this.set(currency)
      this.$bvModal.show('new_beneficiary')
    },
    remove: function (value) {
      this.deleteAccount(value.item)
    },
    uploadDocs: function (data) {
      if (data.item.verified === false) {
        this.editing = data.item
        this.$bvModal.show('upload_bank')
      }
    },
    loadFile: async function (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        reader.onload = (e) => {
          resolve(e.target.result)
        }
        reader.onerror = (e) => {
          reject(e)
        }
        reader.readAsDataURL(file)
      })
    },
    startUpload: async function () {
      if (this.files && this.files.length >= 1) {
        this.uploading = true
        const _notUploaded = []

        for (let i = 0; i < this.files.length; i++) {
          try {
            const _file = await this.loadFile(this.files[i])
            const _mime = _file.substr(_file.indexOf('data:') + 5, _file.indexOf(';base64,') - 5)
            const __file = _file.substr(_file.indexOf(';base64,') + 8)

            const _result = await companyService.attach([{
              name: this.files[i].name,
              type: 'Bank Account Confirmation',
              mime_type: _mime,
              attachment: __file
            }])

            console.log(_result)
          } catch (e) {
            console.log(e)
            _notUploaded.push(this.files[i])
          }
        }

        this.files = _notUploaded
        this.uploading = false

        this.getAccounts()
      }
    }
  },
  watch: {
    accountStatus: function (value) {
      if (value === 'saved') {
        this.details = {
          country: 'ZA',
          currency: 'ZAR',
          bank: null,
          branch: null,
          account_type: null,
          account_number: null,
          account_name: null,
          swift_code: null,
          iban: null
        }
        this.getAccounts()
      }

      if (value === 'loaded') {
        this.saving = false
      }
    },
    'details.bank': function (value) {
      if (this.details.country === 'ZA') {
        const _bank = this.banks.SaBanks.find(bank => bank.name === value)
        if (_bank) {
          this.details.branch = _bank.branch
        }
      }
    },
    'details.country': function (value) {
      this.details.bank = null
      this.details.branch = null
      console.log('updating from watch', this.details.bank)
    }
  }
}
</script>
